import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BillingValidationChecklistState, BillingValidationStatus } from '@common/services/billing-validation.service';

@Component({
    selector: 'sbpro-billing-validation-checklist',
    templateUrl: './billing-validation-checklist.component.html',
    styleUrls: ['./billing-validation-checklist.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BillingValidationChecklistComponent {
    @Input() state: BillingValidationChecklistState | null = null;
    @Input() canUserResolvePendingItems = true;

    trackByStep(_index: number, item: { key: string; step: number }): string {
        return `${item.key}:${item.step}`;
    }

    getStatusLabel(status: BillingValidationStatus): string {
        switch (status) {
            case 'ready':
                return 'Ready';
            case 'failed':
            case 'not-configured':
                return 'Pending';
            default:
                return 'Pending';
        }
    }

    getStatusClass(status: BillingValidationStatus): string {
        switch (status) {
            case 'ready':
                return 'pill-ready';
            case 'failed':
            case 'not-configured':
                return 'pill-pending';
            default:
                return 'pill-pending';
        }
    }

    getTextClass(status: BillingValidationStatus): string {
        switch (status) {
            case 'ready':
                return 'text-dark';
            case 'failed':
            case 'not-configured':
                return 'precheck-pending-text';
            default:
                return 'precheck-pending-text';
        }
    }

    getDescriptionClass(status: BillingValidationStatus): string {
        switch (status) {
            case 'ready':
                return 'text-muted';
            case 'failed':
            case 'not-configured':
                return 'precheck-pending-text';
            default:
                return 'precheck-pending-text';
        }
    }

    getFooterMessage(checklist: BillingValidationChecklistState): string {
        if (checklist.ready) {
            return checklist.message || 'When every item shows Ready, the billing document will load automatically.';
        }

        if (checklist.message?.trim()) {
            return checklist.message;
        }

        if (!this.canUserResolvePendingItems) {
            return 'Please contact your administrator to complete the pending checklist items.';
        }

        return 'Complete the items above to continue.';
    }

    getFooterClass(checklist: BillingValidationChecklistState): string {
        return checklist.ready ? 'text-muted' : 'precheck-pending-text';
    }

    getPendingHelperMessage(): string {
        return this.canUserResolvePendingItems
            ? 'Complete this item to continue.'
            : 'Please contact your administrator to complete this checklist item.';
    }
}
